import { isProductKey, ProductKeyType } from "../models";

import { useSearchParameters } from "./use-search-parameters";

export function useProductKeys(): readonly ProductKeyType[] {
    const { products } = useSearchParameters();
    return products.filter(isProductKey);
}
